// removed by extract-text-webpack-plugin
module.exports = {"common_hidden_text":"QuestionBlock--common_hidden_text--2qjlM","question_block":"QuestionBlock--question_block--9jeX-","question":"QuestionBlock--question--3gaCg","question_is_required_indicator":"QuestionBlock--question_is_required_indicator--tjYQX","question_is_required":"QuestionBlock--question_is_required--2VFF3"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/QuestionBlock/QuestionBlock.css
// module id = 1027
// module chunks = 0